const actions = {
  async list(context, payload) {
    try {
      const response = await this.$api.call("level.list", payload);
      const responseData = response.data;

      context.commit("mutationLevels", responseData);

      return response;
    } catch (error) {
      context.commit("mutationLevels", []);
      throw error;
    }
  },

  async detail(context, payload) {
    try {
      const response = await this.$api.call("level.detail", payload);
      const responseData = response.data;

      context.commit("mutationLevel", responseData);

      return response;
    } catch (error) {
      context.commit("mutationLevel", {});
      throw error;
    }
  },

  async create(_context, payload) {
    try {
      const response = await this.$api.call("level.create", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async edit(_context, payload) {
    try {
      const response = await this.$api.call("level.edit", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async delete(_context, payload) {
    try {
      const response = await this.$api.call("level.delete", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async resetList(context) {
    try {
      context.commit("mutationLevels", []);
      return [];
    } catch (error) {
      context.commit("mutationLevels", []);
      throw error;
    }
  },
};

export default actions;
